import React from 'react'
import DialogModal from 'shared/components/DialogModal'
import PropTypes from 'prop-types'
import Bullet from 'shared/components/Bullet'
import { Typography, Grid, Stack } from '@mui/material'
import { ButtonContained } from 'shared/components/Button'

const PetunjukDialog = ({ open, handleClose, action }) => {
    return (
        <DialogModal open={open} handleClose={handleClose} size='sm' title={action === 'tambah' ? 'Petunjuk Tambah Dokumen' : 'Petunjuk Ubah Dokumen'}>
            <Grid container spacing={3}>
                <Item title='Nomor PK' value='Isi nomor PK yang akan dibuat atau dibagikan.'/>
                <Item title='Judul PK' value='Isi judul atau perihal dokumen PK yang akan dibuat.'/>
                <Item title='Jabatan PK' value='Isi jabatan yang terkait dengan dokumen PK.'/>
                <Item title='Tanggal PK' value='Pilih tanggal dokumen PK menggunakan kolom tanggal yang tersedia.'/>
                <Item title='Penerima PK' value='Pilih penerima dokumen PK melalui Addressbook dengan klik kolom Penerima PK.'/>
                <Item title='Penandatangan' value='Pilih penandatangan dokumen PK dari pilihan yang tersedia. Daftar approval akan disesuaikan berdasarkan penandatangan yang dipilih.'/>
                <Item title='Approval' value='Daftar approval akan ditampilkan secara otomatis sesuai dengan penandatangan yang dipilih.'/>
                <Item title='Tembusan' value='Pilih pihak yang perlu menerima tembusan dokumen melalui Addressbook. Tembusan bersifat opsional.'/>
                <Item title='Status' value='Pilih status dokumen PK, yaitu PPPK atau PPPK Paruh Waktu.'/>
                <Item title='Lampiran' value='Upload dokumen dalam format PDF dengan cara menarik file ke area lampiran atau klik area upload untuk memilih file.'/>
                <Item title='Label Dokumen' value='Setelah dokumen PDF ditampilkan, tambahkan label/tanda tangan pada dokumen sesuai kebutuhan sebelum mengunggah dokumen.'/>
                <Item title='Simpan Draft' value='Gunakan tombol Simpan Draft untuk menyimpan dokumen PK sementara. Pada mode draft, minimal Judul PK harus diisi.'/>
                <Item title='Kirim' value='Gunakan tombol Kirim untuk mengirim dokumen PK setelah seluruh data wajib dan lampiran telah dilengkapi.'/>
            </Grid>

            <Stack justifyContent='flex-end' alignItem='flex-end' marginTop={3} flexDirection='row'>
                <ButtonContained variant='contained' onClick={handleClose}>Tutup</ButtonContained>
            </Stack>
        </DialogModal>
    )
}

const Item = ({ title, value }) => {
    return (
        <>
            <Grid item container spacing={2}>
                <Grid item xs={12} md={4}>
                    <Stack direction='row' alignItems={'center'} spacing={2}>
                        <Bullet />
                        <Typography variant='h5' fontWeight='500'>{title}</Typography>
                    </Stack>
                </Grid>
                <Grid item xs={12} md={8}>
                    <Typography>{value}</Typography>
                </Grid>
            </Grid>
        </>
    )
}

Item.propTypes = {
    title: PropTypes.string,
    value: PropTypes.string
}

PetunjukDialog.propTypes = {
    open: PropTypes.bool,
    action: PropTypes.string,
    handleClose: PropTypes.func,
}

export default PetunjukDialog
